import React from "react";
import ToggleableButton from "../../../../../components/toggleableButton/toggleableButton";
import { useDispatch, useSelector } from "react-redux";
import {actionCreators} from "../redux/sagas/averageNumberOfClientsPerClassSagas";

const CompareDates = ()=>{
  const {compare} = useSelector(state => state.averageNumberOfClientsPerClassReducer.selectedFilters)
  const dispatch = useDispatch()

  return <ToggleableButton
    isActive={compare}
    isRadio={true}
    title="average-number-clients-per-class-compare-dates"
    onClick={ data=>dispatch(actionCreators.updateCompareDates(data)) }
  />
}

export default CompareDates
